import { Pressable, StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { useNavigation } from '@react-navigation/native';
import { useStoreActions, useStoreState } from '@/stores/store';
import { useCallback } from 'react';
import { Icon } from '@/components/Icon';
import colors, { appTheme } from '@/config/colors';
import { SetCard } from './SetCard';
import { hasInternetAsync } from './helpers';

const styles = StyleSheet.create({
  setItemStyle: {
    flex: 1,
  },
  container: {
    gap: 8,
    paddingHorizontal: 16,
    marginBottom: 8,
  },
  headerContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  heading: {
    fontSize: 20,
    fontWeight: '700',
    color: colors.darkBlue,
  },
  setContainer: { rowGap: 16 },
});

const screenName = {
  Wörtersets: 'WordSet',
  Sätzesets: 'SentenceSet',
  Textesets: 'TextSet',
};

export function Set({
  type,
  data,
  index,
  patientID,
  fetchPatientsWrapper,
  selectedPatientFullName,
  patientsSyncing,
  refreshPatient,
}) {
  const { isTherapistDemo, toolTipNumber } = useStoreState((store) => store);
  const { setToolTipNumber, setGlobalPopupState } = useStoreActions(
    (action) => ({
      setToolTipNumber: action.setToolTipNumber,
      setGlobalPopupState: action.setGlobalPopupState,
    }),
  );

  const { navigate } = useNavigation();

  const handlePlusPress = useCallback(async () => {
    if (isTherapistDemo && toolTipNumber === 3) {
      setToolTipNumber(0);
    }
    const hasInternet = await hasInternetAsync();
    if (hasInternet)
      return navigate(screenName[type], { selectedID: patientID });
    setGlobalPopupState({
      headerText: 'Keine Verbindung zum neolexon Server',
      bodyText:
        'Überprüfen Sie Ihre Internetverbindung und versuchen es erneut.',
      leftButton: '',
      rightButton: '',
    });
  }, [type, patientID, toolTipNumber]);

  const renderedSet = () => (
    <View style={styles.container}>
      <View style={styles.headerContainer}>
        <Text style={styles.heading}>{type}</Text>
        <Pressable onPress={handlePlusPress}>
          <Icon name="plusCircle" color={appTheme.primary} size={30} />
        </Pressable>
      </View>
      {data?.length > 0 ? (
        <View style={styles.setContainer}>
          {data.map((eachData, index) => (
            <SetCard
              selectedPatientFullName={selectedPatientFullName}
              fetchPatientsWrapper={fetchPatientsWrapper}
              patientID={patientID}
              type={type}
              key={eachData._id}
              id={eachData._id}
              data={eachData}
              patientsSyncing={patientsSyncing}
              indexSetCard={index}
              refreshPatient={refreshPatient}
            />
          ))}
        </View>
      ) : (
        <Text>Noch keine {type} erstellt</Text>
      )}
    </View>
  );

  return <View style={[styles.setItemStyle]}>{renderedSet()}</View>;
}
